import loadable from "@loadable/component";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import PickupRequesticon from "../../Icons/PickupRequesticon";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router-dom";
import { useState } from "react";
import useGetHook from "../../customHooks/useGetHook";
const PickupNoteListComponent = loadable(
  () => import("../../Components/PickupNotes/PickupNoteList")
);
const PickupNoteList = () => {
  const { id } = useParams();
  
 
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <PickupRequesticon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Pickup Notes
        </span>
      </div>
      <PickupNoteListComponent />
    </>
  );
};

export default PickupNoteList;

